import { createReducer, on, Action } from '@ngrx/store';
import * as vehicleGroupsActions from '../actions/vehicle-groups.actions';
import { VehicleGroupApiModel } from 'app/models/vehicle-groups-api.model';
import * as userActions from '@core/auth/@store/user/user.actions';
import { MwPayloadModel } from 'app/models/payload.model';

export interface State {
  vehicleGroups: MwPayloadModel<VehicleGroupApiModel[]>;
  isLoading: boolean;
  isLoaded: boolean;
  isSaving: boolean;
}

export const initialState: State = {
  vehicleGroups: {
    results: [],
    count: 0,
  },
  isLoading: false,
  isLoaded: false,
  isSaving: false,
};

const featureReducer = createReducer(
  initialState,
  on(vehicleGroupsActions.loadVehicleGroups, (state: State) => ({
    ...state,
    isLoading: true,
  })),
  on(
    vehicleGroupsActions.loadVehicleGroupsSuccess,
    (state: State, { response }) => ({
      ...state,
      isLoading: false,
      isLoaded: true,
      vehicleGroups: {
        results: response.results,
        count: response.results.length,
      },
    })
  ),
  on(
    vehicleGroupsActions.createVehicleGroup,
    vehicleGroupsActions.updateVehicleGroup,
    (state) => ({
      ...state,
      isSaving: true,
    })
  ),
  on(
    vehicleGroupsActions.createVehicleGroupSuccess,
    vehicleGroupsActions.createVehicleGroupFailed,
    vehicleGroupsActions.updateVehicleGroupSuccess,
    vehicleGroupsActions.updateVehicleGroupFailed,
    (state) => ({
      ...state,
      isSaving: false,
    })
  ),
  on(
    vehicleGroupsActions.resetVehicleGroups,
    userActions.setActiveCompany,
    (state: State) => initialState
  )
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
